<div class="table-responsive">
  <table suiteRfbTable class="tabela-filtros">
    <caption>Filtros da Pesquisa</caption>
    <tbody>
      @for (parChaves of this.paresChavesCampos; track $index) {
      <tr>
        <th [class]="this.classesTh" scope="col">{{ parChaves[0] }}</th>
        <td [class]="this.classesTd">{{ this.mapeamentoCampos[parChaves[0]] | vazio }}</td>

        <th [class]="this.classesTh" scope="col">{{ parChaves[1] }}</th>
        <td [class]="this.classesTd">{{ parChaves[1] != null ? (this.mapeamentoCampos[parChaves[1]] | vazio) : "" }}</td>
      </tr>
      }
    </tbody>
  </table>
</div>